import Http from '@/utils/http'
import cache from '@/utils/cache'
import { Message } from 'element-ui'

const BASE_URL = process.env.VUE_APP_BASE_URL
const BASE_TIME = 10000

const http = new Http({
  baseURL: BASE_URL,
  timeout: BASE_TIME,
  interceptors: {
    requestInterceptor: config => {
      // config.headers.Authorization = `Bearer ${token}`
      const token = cache.getCache('token')
      config.headers.token = token
      // config.headers.Authorization = token
      return config
    },
    requestInterceptorCatch: error => {
      // console.log('请求错误')
      return error
    },
    responseInterceptor: config => {
      // console.log('响应成功的拦截')
      if (config.data.code === 1017) {
        cache.removeCache('token')
        Message.error(config.data.error || '服务器异常，请稍后重试')
      }
      return config
    },
    responseInterceptorCatch: error => {
      // console.log('响应错误')
      return error
    }
  }
})

export default http
